<template>
   <section id="app">
    <!-- 商户 -->
    <section class="mui-cells shop">
      <section
        class="mui-cell"
        v-if="shop && shop.id"
        >
        <section class="mui-cell__hd">
          <img
            class="avator"
            :src="shop.headFigureUrlRebuild"
            alt="">
        </section>

        <section class="mui-cell__bd">
          <p class="name">
            {{shop.name}}
          </p>
          <p class="owner">
            店主姓名：{{shop.shopOwnerName}}
          </p>
          <p class="address">
            店铺地址：{{shop.addressDetail}}
          </p>
        </section>
      </section>

      <section
        class="mui-cell no-shop"
        v-else
        >
        <p>
          这个手机号还没有在美甲帮店务通开店或绑定到店铺！<br>
          没关系，支付后用这个手机号去注册登录就好啦~ <br>
          系统将自动为你激活账户！
        </p>
      </section>
    </section>

    <!-- 商品 -->
    <section class="mui-cells__title">
      <i class="icon icon-cut"></i>
      <span>已选择商品</span>
    </section>
    <section
      class="mui-cells production"
      v-if="production || production.id"
      >
      <section class="mui-cell">
        <section class="mui-cell__bd">
          <p class="title">
            {{production.name}}
          </p>
          <p class="description">
            {{production.desc}}
          </p>
        </section>

        <section class="mui-cell__ft">
          <span class="origin">
            ¥{{production.originalPrice | money}}
          </span>
          <span class="price">
            ¥{{production.salePrice | money}}
          </span>
        </section>
      </section>
    </section>

    <!-- 支付方式 -->
    <section class="mui-cells__title">
      <i class="icon icon-cut"></i>
      <span>支付方式</span>
    </section>
    <section class="mui-cells payment">
      <a
        class="mui-cell"
        v-for="payment in payments"
        @click="selectedPayment(payment)"
        >
        <section class="mui-cell__hd">
          <i
            class="icon"
            :class="payment.icon"
            ></i>
        </section>
        <section class="mui-cell__bd">
          {{payment.desc}}
        </section>
        <section class="mui-cell__ft">
          <span
            class="checker"
            :class="{'is-selected': payment.id === paymentId}"
            >
            <span></span>
          </span>
        </section>
      </a>
    </section>

    <!-- alipay -->
    <section
      class="alipy-form"
      v-html="alipyFrom"
      >
    </section>

    <!-- 付款 -->
    <section class="pay">
      <section class="price">
        合计：
        <span class="total">
          ¥{{production.salePrice | money}}
        </span>
      </section>

      <a
        class="button_primary button"
        :class="{'is-loading': submiting}"
        @click="pay()"
        >
        {{payText}}
      </a>
    </section>
  </section>
</template>

<script>

import api from 'api'
import store from 'store'

import loading from 'components/loading'

export default {
  name: 'Pay',

  components: {
    mLoading: loading,
  },

  data() {
    return {
       /*
        ALIPAY(1, "alipay", "支付宝", true),
        WECHAT(2, "wechat", "微信", true),
        UNIONPAY(3, "unionpay", "银联", true),
        UNIONPAY(4, "alipay-wap", "支付宝网页", true),
        IAP(10, "iap", "苹果内购", false),;
      */
      // 支付
      paymentId: 0,
      payments: [],
      alipyFrom: null,

      // 店铺
      shop: {},

      // 商品
      production: {},

      // 状态
      submiting: false,
    }
  },

  computed: {
    payText() {
      return this.submiting ? '支付中..' : '立即支付'
    },
  },

  methods: {
    selectedPayment(payment) {
      this.paymentId = payment.id
    },

    pay() {
      if (!this.paymentId) return

      const getAppUser = () => {
        const util = window.App.Util || {}

        if (util.mjb) {
          return new Promise((resolve) => {
            util.getData({
              path: 'user',
              data: {
                fields: 'uid',
              },
              success: (res) => {
                const userChannel = 2 // 用户渠道, 默认:0, 店务通:1, 美甲帮:2
                const uid = res.error_code === 0 ? res.data.uid : null
                resolve({
                  userChannel,
                  uid,
                })
              },
              error: (e) => {
                console.log('获取美甲帮用户信息失败..', e)
                // reject(e)
                resolve({})
              },
            })
          })
        }

        return Promise.resolve({})
      }

      const payApply = (appUser) => {
        return api({
          method: 'post',
          url: '/subscribe/payApply',
          params: {
            token: store.token,
            tel: store.tel,
            shopId: this.shop.id,
          },
          data: {
            quantity: 1,
            productId: this.production.id,
            payChannel: this.paymentId,
            userChannel: appUser.userChannel,
            outUid: appUser.uid,
          },
        })
      }

      this.submiting = true

      switch (this.paymentId) {
        case 4 : { // 支付宝网页支付
          getAppUser()
            .then((user) => {
              console.log(user)
              return payApply(user)
            })
            .then(({data}) => {
              // 取支付宝需要的字段 跳转支付宝支付
              // zepto写法: window.$('body').append(data.orderInfo)
              this.alipyFrom = data.orderInfo
              this.$nextTick(() => {
                document.forms.alipaysubmit.submit()
                this.submiting = false
              })
            })
            .catch((error) => {
              alert(error.errMsg || '提交订单失败')
              this.submiting = false
            })

          break;
        }

        default: {
          console.log(`暂不支持${this.paymentId}支付`)
          this.submiting = false
        }
      }
    },
  },

  created() {
    const payments = store.payments || []
    const icons = {
      1: 'icon-alipay',
      2: 'icon-wechat',
      4: 'icon-alipay',
    }
    payments.forEach((item) => {
      const payment = item
      payment.icon = icons[`${payment.id}`]
    })

    if (payments.length) {
      this.paymentId = payments[0].id
    }

    this.payments = payments
    this.shop = store.shop || {}
    this.production = store.production || {}

    this.loading = false
  },
}

</script>

<style lang="scss" scoped>
.shop {
  .mui-cell {
    padding-left: 25px;
    padding-right: 25px;

    &.no-shop {
      padding-left: 16px;
      padding-right: 16px;

      >p {
        font-size: 14px;
        color: #262626;
        line-height: 21px;
      }
    }
  }

  img.avator {
    width: 52px;
    height: 52px;
    border-radius: 50%;
    margin-right: 19px;
  }

  .name {
    font-size: 16px;
    color: #262626;
  }

  .owner {
    margin-top: 9px;
    font-size: 12px;
    color: #858585;
  }

  .address {
    margin-top: 7px;
    font-size: 12px;
    color: #858585;
  }
}

.production {
  .mui-cell {
    padding-bottom: 10px;
  }

  .title {
    font-size: 16px;
    color: #262626;
  }

  .description {
    margin-top: 10px;
    font-size: 12px;
    color: #858585;
  }

  .price {
    font-size: 16px;
    color: #FF519F;
  }

  .origin {
    font-size: 10px;
    color: #C4C4C4;
    text-decoration: line-through;
  }
}

.payment {
  .checker {
    display: inline-block;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 1px solid #858585;
    text-align: center;

    > span {
      display: inline-block;
      width: 16px;
      height: 16px;
      border-radius: 10px;
      background-color: transparent;

      margin-top: 2px;
    }

    &.is-selected {
      border: 1px solid #FF519F;

      > span {
        background-color: #FF519F;
      }
    }
  }
}

.pay {
  display: flex;
  align-items: center;

  position: fixed;
  width: 100%;
  bottom: 0;
  left: 0;
  height: 50px;
  background-color: #fff;

  &:before {
    content: " ";
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    height: 1px;
    border-top: 1px solid #C7C7C7;
    color: #C7C7C7;
    transform-origin: 0 0;
    transform: scaleY(0.5);
  }

  .price {
    flex: 1;
    font-size: 16px;
    color: #262626;
    padding-left: 16px;

    .total {
      color: #FF519F;
    }
  }

  .button {
    display: block;
    width: 110px;
    height: 50px;
    line-height: 50px;
    border-radius: 0;
  }
}

.icon-cut {
  width: 3px;
  height: 17px;
  background-image: url('~assets/images/icon-cut.png');
  background-size: contain;
  background-repeat: no-repeat;

  vertical-align: -3px;
  margin-right: 6px;
}

.icon-wechat {
  width: 25px;
  height: 25px;
  background-image: url('~assets/images/icon-wechat.png');
  background-size: contain;
  background-repeat: no-repeat;

  margin-right: 20px;
}

.icon-alipay {
  width: 25px;
  height: 25px;
  background-image: url('~assets/images/icon-alipay.png');
  background-size: contain;
  background-repeat: no-repeat;

  vertical-align: -3px;
  margin-right: 20px;
}

.alipy-form {
  display: none;
}

</style>




// WEBPACK FOOTER //
// Pay.vue?595ecec4